
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 9717","d":"M25 0A25 25 0 110 25 25 25 0 0125 0z","fill":"#ff3b61"}}),_c('g',{attrs:{"data-name":"Group 41988","fill":"#fff"}},[_c('path',{attrs:{"data-name":"Path 11390","d":"M32.627 30.721l-6.444-5.727 6.444-5.73a.79.79 0 00-1.049-1.182l-6.582 5.852-6.583-5.849a.79.79 0 00-1.049 1.179l6.443 5.73-6.443 5.727a.79.79 0 101.049 1.181l6.583-5.851 6.582 5.851a.79.79 0 001.049-1.181"}}),_c('path',{attrs:{"data-name":"Path 11391","d":"M25 40a15 15 0 1110.61-4.394A15 15 0 0125 40m0-28.426A13.423 13.423 0 1038.42 25 13.423 13.423 0 0025 11.574z"}})])])
          )
        }
      }
    